import './contact-us-form.styles.css';
import Button from '../button/button.component';

const ContactUsForm = () => {
  return (
    <form className="contact-us-form">
        <textarea placeholder="پیام" className="contact-text-area"></textarea>
        <div className="contact-us-form-row-wrapper">
            <input type="text" placeholder="نام" className="contact-us-form-input" name='name' />
            <input type="email" placeholder="ایمیل" className="contact-us-form-input" name='name' />
        </div>
        <Button className="contact-us-form-button">
            ارسال
        </Button>
    </form>
  )
}

export default ContactUsForm;